import { object } from "yup";
import { ApiResponse } from "@typeDefinitions/Api";
import { APIMethods } from "@typeDefinitions/enums";
import { getDataAPI } from "@utils/api";
import { logFetchValidateError } from "@utils/validate";
import {
  ClinicResource,
  clinicResourceSchema,
} from "@client/resources/ClinicResource";

export type GetClinicResponse = ApiResponse<ClinicResource>;

export const getClinicAPI = async (): Promise<GetClinicResponse> => {
  const response = await getDataAPI("/dietitian/clinic", APIMethods.GET);
  const responseSchema = object({
    data: clinicResourceSchema.required(),
  });
  return await responseSchema
    .validate(response)
    .catch(logFetchValidateError("/dietitian/clinic"));
};
